import { useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2, RefreshCw } from "lucide-react";
import api from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

export default function AiStatusBanner() {
  const [st, setSt] = useState(null);
  const load = () => api.get("/admin/ai-status").then(({ data }) => setSt(data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!st) return null;

  const { levels, pictures } = st;
  const stats = (
    <div className="flex flex-wrap gap-x-5 gap-y-1 text-xs mt-2" data-testid="ai-ready-stats">
      <span data-testid="ai-levels-en">Levels ready (EN): <b>{levels.ready_en}/{levels.total}</b></span>
      <span data-testid="ai-levels-fr">Levels ready (FR): <b>{levels.ready_fr}/{levels.total}</b></span>
      <span data-testid="ai-pictures-checked">Pictures checked: <b>{pictures.checked}</b></span>
      <span data-testid="ai-pictures-waiting">Waiting for check: <b>{pictures.waiting}</b></span>
      <span data-testid="ai-pictures-hidden">Hidden: <b>{pictures.hidden}</b></span>
    </div>
  );

  if (st.limit_hit) {
    return (
      <div className="mb-6 rounded-2xl border-2 border-red-400 bg-red-950/70 text-red-100 p-4" data-testid="ai-limit-banner">
        <div className="flex items-start gap-3">
          <AlertTriangle className="text-red-300 shrink-0 mt-0.5" size={22} />
          <div className="flex-1">
            <p className="font-bold">AI daily spending limit reached — since {fmt(st.last_limit_at)}</p>
            <p className="text-sm mt-1 text-red-200">
              New levels, hints, French translations, pictures and emails can't be made until the limit resets or is raised.
              Children can still play levels that are already ready. To raise it: <b>Profile → Buy Credits → Universal Key → daily spend limit</b>.
            </p>
            {stats}
          </div>
          <button onClick={load} data-testid="ai-status-refresh" className="text-red-200 hover:text-white" title="Refresh"><RefreshCw size={16} /></button>
        </div>
      </div>
    );
  }
  return (
    <div className="mb-6 rounded-2xl border-2 border-slate-700 bg-slate-800 p-4" data-testid="ai-ok-banner">
      <p className="text-sm font-semibold flex items-center gap-2"><CheckCircle2 size={16} className="text-green-400" /> AI service working{st.last_ok_at ? ` · last success ${fmt(st.last_ok_at)}` : ""}</p>
      {stats}
    </div>
  );
}
